import { QueryClientProvider } from "@tanstack/react-query"
import { MemoryRouter } from "react-router-dom"
import { StyleProvider } from "@ant-design/cssinjs"
import { ConfigProvider } from "antd"
import { queryClient } from "api/queryClient"

type Props = { shadowRoot: ShadowRoot; children: React.ReactNode }

export const ShadowDomProviders = ({ shadowRoot, children }: Props) => (
	<QueryClientProvider client={queryClient}>
		<MemoryRouter initialEntries={[window.location.pathname + window.location.search]}>
			<StyleProvider container={shadowRoot}>
				{/* Brand blue (--clr-main) for AntD's active/focus state so the right sidebar's form
				    controls match our custom keyboard-focus ring. colorPrimary is otherwise unset app-wide,
				    so AntD would fall back to its default #1677ff and clash with the #0047FF ring. */}
				<ConfigProvider theme={{ token: { colorPrimary: "#0047FF" } }}>{children}</ConfigProvider>
			</StyleProvider>
		</MemoryRouter>
	</QueryClientProvider>
)
